import "./player.css"
import "media-chrome"

class StickyPlayer extends HTMLElement {
  static {
    customElements.define("sticky-player", this)
  }

  connectedCallback() {
    let timestamps;
    const bigOutput = document.querySelector("output")

    document.querySelector("audio[slot='media']").addEventListener("timeupdate", event => {
      if (!timestamps) timestamps = [...document.querySelectorAll("[data-audio-timestamp]")].reverse()
      if (bigOutput) {
        document.querySelector("output").textContent = Math.round(event.target.currentTime)
      }
      document.querySelector(".currently-playing")?.classList?.remove("currently-playing")
      const firstTimestamp = timestamps.find(el => {
        return event.target.currentTime > Number(el.dataset.audioTimestamp)
      })
      if (firstTimestamp) firstTimestamp.classList.add("currently-playing")
    })

    document.querySelector("main > article").addEventListener("click", event => {
      if (document.getSelection().type == "Range") return;

      if (event.target.closest("[data-audio-timestamp]")) {
        document.querySelector("audio[slot='media']").currentTime = Number(event.target.closest("[data-audio-timestamp]").dataset.audioTimestamp) + 0.01
      }
    })

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const notice = document.querySelector("#episode-audio-notice")
        if (entry.isIntersecting) {
          notice.style.height = ""
          notice.append(document.querySelector("media-controller"))
        } else if (!document.querySelector("audio[slot='media']").paused && document.documentElement.scrollTop > 500) {
          const notice = document.querySelector("#episode-audio-notice")
          notice.style.height = `calc(${notice.offsetHeight}px - 6px - calc(2 * ${notice.computedStyleMap().get("padding-block")}))`
          this.append(document.querySelector("media-controller"))
        }
      })
    }, {
      threshold: 1
    })
    observer.observe(document.querySelector("h1"))    
  }
}
